import Content from './Content.component';
import VirtualizedList from './VirtualizedList.component';
import { cellDictionary, headerDictionary } from './utils/dictionary';

import { ActionsColumn } from './CellActions';
import { BadgeColumn } from './CellBadge';
import { CheckboxColumn } from './CellCheckbox';
import { DatetimeColumn } from './CellDatetime';
import { TextIconColumn } from './CellTextIcon';
import { LinkColumn } from './CellLink';
import { TitleColumn } from './CellTitle';
import { BooleanColumn } from './CellBoolean';
import { LabelColumn } from './CellLabel';
import { IconTextColumn } from './CellIconText';
import { QualityBarColumn } from './CellQualityBar';
import { MappedDataColumn } from './CellMappedData';
import HeaderResizable from './HeaderResizable';
import RowCollapsiblePanel from './RowCollapsiblePanel';

import { listTypes, SORT_BY, SELECTION_MODE } from './utils/constants';
import * as rowUtils from './utils/gridrow';

// For compatibility
VirtualizedList.Content = Content;

VirtualizedList.Actions = ActionsColumn;
VirtualizedList.Badge = BadgeColumn;
VirtualizedList.Checkbox = CheckboxColumn;
VirtualizedList.Datetime = DatetimeColumn;
VirtualizedList.Text = Content;
VirtualizedList.TextIcon = TextIconColumn;
VirtualizedList.Title = TitleColumn;
VirtualizedList.Boolean = BooleanColumn;
VirtualizedList.Label = LabelColumn;
VirtualizedList.Link = LinkColumn;
VirtualizedList.IconText = IconTextColumn;
VirtualizedList.QualityBar = QualityBarColumn;
VirtualizedList.MappedData = MappedDataColumn;
VirtualizedList.RowCollapsiblePanel = RowCollapsiblePanel;
VirtualizedList.HeaderResizable = HeaderResizable;
VirtualizedList.cellDictionary = cellDictionary;
VirtualizedList.headerDictionary = headerDictionary;

VirtualizedList.rowUtils = rowUtils;

VirtualizedList.LIST_TYPES = listTypes;
VirtualizedList.SORT_BY = SORT_BY;
VirtualizedList.SELECTION_MODE = SELECTION_MODE;

export default VirtualizedList;
